export const environment = {
  production: true,
  // Same origin: nginx on the admin host proxies /api to the backend, so this
  // must stay relative. An absolute URL points the admin at another environment.
  baseUrl: '/api/',
  // School portal origin, for Mirror Mode. Set this to the real portal host -
  // it is a different origin from the admin, so it cannot be relative.
  portalUrl: 'https://school.issoindia.in',
};
